import axios from "../axios";


const API_URL = axios.defaults.baseURL;
const USER_URL = "/user";
const EVENTS_URL = "/events";


export const getOrganiserEventsDetailsProfile = (profileId) => {
    return axios.get(
        `${API_URL}${USER_URL}${EVENTS_URL}`,
        {
            params: {
                profile_id: profileId
            }
        }
    );
};
